module.exports = __webpack_public_path__ + "img/39.1ef49c5f.jpg";